module.exports = __webpack_public_path__ + "img/listbanner.47edb9e9.png";